/**
 * Created by zinia on 4/19/2020.
 */
import {Action} from '@ngrx/store';
import {TreeItemNode} from '@shared/models/tree-selector.models';
import {FxRateReportModel} from '../../models/fx-rate-report.model';
export const GET_COUNTRIES_TREE_DATA = '[FxRates] GET_COUNTRIES_TREE_DATA';
export const GET_COUNTRIES_TREE_DATA_SUCCESS = '[FxRates] GET_COUNTRIES_TREE_DATA_SUCCESS';
export const GET_COUNTRIES_TREE_DATA_FAILED = '[FxRates] GET_COUNTRIES_TREE_DATA_FAILED';
export const GET_CURRENCIES_TREE_DATA = '[FxRates] GET_CURRENCIES_TREE_DATA';
export const GET_CURRENCIES_TREE_DATA_SUCCESS = '[FxRates] GET_CURRENCIES_TREE_DATA_SUCCESS';
export const GET_CURRENCIES_TREE_DATA_FAILED = '[FxRates] GET_CURRENCIES_TREE_DATA_FAILED';
export const GET_FX_RATE_REPORT = '[FxRates] GET_FX_RATE_REPORT';
export const GET_FX_RATE_REPORT_SUCCESS = '[FxRates] GET_FX_RATE_REPORT_SUCCESS';
export const GET_FX_RATE_REPORT_FAILED = '[FxRates] GET_FX_RATE_REPORT_FAILED';
export const CLEAR_FX_RATE_REPORT_DATA = '[FxRates] CLEAR_FX_RATE_REPORT_DATA';

export class GetCountriesTreeDataAction implements Action {
  readonly type = GET_COUNTRIES_TREE_DATA;
  constructor(public reportId: string,public currencyType: string) {}
}

export class GetCountriesTreeDataSuccessAction implements Action {
  readonly type = GET_COUNTRIES_TREE_DATA_SUCCESS;

  constructor(public reportId: string, public currencyType : string, public payload: TreeItemNode[]) {}
}

export class GetCountriesTreeDataFailedAction implements Action {
  readonly type = GET_COUNTRIES_TREE_DATA_FAILED;

  constructor(public err: any) {}
}
export class GetCurrenciesTreeDataAction implements Action {
  readonly type = GET_CURRENCIES_TREE_DATA;
  constructor(public reportId: string,public currencyType: string ) {}
}

export class GetCurrenciesTreeDataSuccessAction implements Action {
  readonly type = GET_CURRENCIES_TREE_DATA_SUCCESS;

  constructor(public reportId: string, public currencyType: string, public payload: TreeItemNode[]) {}
}

export class GetCurrenciesTreeDataFailedAction implements Action {
  readonly type = GET_CURRENCIES_TREE_DATA_FAILED;

  constructor(public err: any) {}
}
export class GetFxRateReportAction implements Action {
  readonly type = GET_FX_RATE_REPORT;
  constructor(public reportId: string) {}
}

export class GetFxRateReportSuccessAction implements Action {
  readonly type = GET_FX_RATE_REPORT_SUCCESS;

  constructor(public reportId: string, public payload: FxRateReportModel) {}
}

export class GetFxRateReportFailedAction implements Action {
  readonly type = GET_FX_RATE_REPORT_FAILED;

  constructor(public err: any) {}
}

export class ClearFxRateReportAction implements Action {
  readonly type = CLEAR_FX_RATE_REPORT_DATA;
  constructor(public reportId: string) {}
}

export type fxRateActions = GetCountriesTreeDataAction
  |GetCountriesTreeDataSuccessAction
  |GetCountriesTreeDataFailedAction
  |GetCurrenciesTreeDataAction
  |GetCurrenciesTreeDataSuccessAction
  |GetCurrenciesTreeDataFailedAction
  |GetFxRateReportAction
  |GetFxRateReportSuccessAction
  |GetFxRateReportFailedAction
  |ClearFxRateReportAction;
